"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Details = void 0;

var _react = _interopRequireDefault(require("react"));

var _detailsTabs = require("../common/details-tabs");

var _detailsList = require("./details-list");

var _jsxRuntime = require("react/jsx-runtime");

var Details = function Details(_ref) {
  var _creditCardOffer$mark;

  var creditCardOffer = _ref.creditCardOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab;
  var title = 'Details';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      shownTab: shownTab,
      handleShownTab: handleShownTab,
      title: title
    }), title === shownTab && /*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsList.DetailsList, {
      items: ((_creditCardOffer$mark = creditCardOffer.marketingCopy) !== null && _creditCardOffer$mark !== void 0 ? _creditCardOffer$mark : []).map(function (copy) {
        return {
          description: copy
        };
      })
    })]
  });
};

exports.Details = Details;
//# sourceMappingURL=details.js.map